module.exports = __webpack_public_path__ + "static/media/2_Nic_P@2x.d2874c10.jpg";